module.exports = __webpack_public_path__ + "static/media/AgroPack.3a94f199.woff";